<template>
  <div :class="type">
    <h1 v-if="title">{{ title }}</h1>
    <ul>
      <li v-for="(li, idx) in list" :key="idx">
        <a class="cover" v-if="li.img" @click="onClickList(li)">
          <div class="img-cover">
            <img
              :src="require(`@/assets/img/${li.img}s.png`)"
              :alt="li.title + ' - ' + li.vtn"
            />
          </div>
          <h1 v-if="li.title">{{ li.title }}</h1>
          <h2 v-if="li.vtn">{{ li.vtn }}</h2>
        </a>
        <div v-else>
          <h1 v-if="li.title">{{ li.title }}</h1>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "List",
  props: {
    type: String,
    title: String,
    list: Array,
  },
  data() {
    return {
      isClick: false,
      value: null,
    };
  },
  methods: {
    onClickList(prop) {
      this.$emit("onClickList", prop);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/utils/scss/fluid-typo.scss";

h1 {
  margin: 0;
  @include fluid-type(320px, 1600px, 12px, 24px);
  font-weight: bold;
  color: #2d2a29;
}
h2 {
  margin: 0;
  @include fluid-type(320px, 1600px, 8px, 16px);
  font-weight: bold;
  color: #6a615f;
}
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
li {
  margin-bottom: 20px;
}

.imgText {
  ul {
    margin-top: 28px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    li {
      margin-bottom: 24px;
      width: 30%;
      .cover {
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        align-items: center;
        .img-cover {
          box-sizing: border-box;
          overflow: hidden;
          @include fluid-area(320px, 1600px, 80px, 320px);
          border: 1px solid #b3a3a3;
          border-radius: 100%;
          background: #fff;

          img {
            width: 100%;
            height: 100%;
          }
        }
        h1 {
          margin-top: 10px;
          margin-bottom: 2px;
        }
      }
    }
  }
}

.text {
  background: #fcfafa;
  padding: 20px;
  margin: 0 25px;
  h1 {
    color: #726a68;
    font-weight: bold;
    margin-bottom: 24px;
  }
  ul {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    li {
      margin-bottom: 0px;
      width: 50%;
      h1 {
        &::before {
          display: inline-block;
          content: "•";
          margin-right: 6px;
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {
  .imgText,
  .text {
    max-width: 70%;
    margin: 0 auto 28px;
  }

  .img-cover {
    max-width: 240px;
    max-height: 240px;
    margin: 50px 50px 24px;
  }

  .imgText {
    ul {
      li {
        .cover {
          .img-cover {
            transition: box-shadow 0.4s ease-in-out;
          }
          &:hover {
            .img-cover {
              box-shadow: 0 0 0 4px #b3a3a3;
            }
            h1 {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
}
</style>
